import {
  VERIFY_TOKEN_STARTED, VERIFY_TOKEN_END, USER_LOGIN_STARTED, USER_LOGIN_FAILURE, VERIFY_USER_SUCCESS, USER_LOGOUT, UPDATE_USER, UPDATE_LAST_VISITED_ROUTE, UPDATE_CHILD_USER, REMOVE_CHILD, UPDATE_SCHOOL, CHANGE_SUPERADMIN_VIEW, UPDATE_STUDENT_USER
} from "../actions/actionTypes";

// define initial state of auth reducer
const initialState = {
  token: "", // manage the access token
  expiredAt: null, // manage expiry time of the access token
  user: {}, // manage the user details
  authLoading: true, // to indicate that the auth API is in progress
  isAuthenticated: false, // consider as a authentication flag
  userLoginLoading: false, // to indicate that the user signin API is in progress
  loginError: null, // manage the error of the user signin API,
  lastVisitedRoute: "",
  superAdmin: {
    token: "",
    user: {},
    expiredAt: null,
    isViewChanged: false
  },
  role: null
};

// update store based on type and payload and return the state
const auth = (state = initialState, action) => {
  switch (action.type) {
    // verify token - started
    case VERIFY_TOKEN_STARTED: {
      const { silentAuth } = action.payload;
      return silentAuth ? {
        ...state
      } : initialState;
    }
    // verify token - ended/failed
    case VERIFY_TOKEN_END: {
      return {
        ...state,
        authLoading: false
      };
    }
    // user login - started
    case USER_LOGIN_STARTED: {
      return {
        ...state,
        userLoginLoading: true
      };
    }
    // user login - ended/failed
    case USER_LOGIN_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        loginError: error,
        userLoginLoading: false
      };
    }
    // verify token - success
    case VERIFY_USER_SUCCESS: {
      const { token, expiredAt, user } = action.payload;
      if (user.role === 'SUPERADMIN') {
        return {
          ...state,
          superAdmin: {
            ...state.superAdmin,
            token,
            user,
            expiredAt
          },
          isAuthenticated: true,
          authLoading: false,
          userLoginLoading: false,
          role: user.role
        };
      } else {
        return {
          ...state,
          token,
          expiredAt,
          user,
          isAuthenticated: true,
          authLoading: false,
          userLoginLoading: false,
          role: user.role
        };
      }
    }
    // handle user logout
    case USER_LOGOUT: {
      return {
        ...initialState,
        authLoading: false
      };
    }
    // update user info
    case UPDATE_USER: {
      const { user } = action.payload;
      const { firstName, lastName, email, phone, avatarUrl } = user;
      if (state.role === 'SUPERADMIN') {
        return {
          ...state,
          superAdmin: {
            ...state.superAdmin,
            user: {
              ...state.superAdmin.user,
              firstName,
              lastName,
              email,
              phone,
              avatarUrl
            }
          },
        };
      } else {
        return {
          ...state,
          user: {
            ...state.user,
            firstName,
            lastName,
            email,
            phone,
            avatarUrl
          },
        };
      }
    }
    // update user info
    case UPDATE_CHILD_USER: {
      const { parentStudent } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          Parent: {
            ...state.user.Parent,
            ParentStudentAssocs: parentStudent
          }
        }
      };
    }
    //remove child
    case REMOVE_CHILD: {
      const { studentId } = action.payload;
      const updateChild = state.user.Parent.ParentStudentAssocs.filter(item => item.studentId !== studentId);
      return {
        ...state,
        user: {
          ...state.user,
          Parent: {
            ...state.user.Parent,
            ParentStudentAssocs: updateChild
          }
        }
      };
    }
    //update last visited route
    case UPDATE_LAST_VISITED_ROUTE: {
      const { url } = action.payload;
      return {
        ...state,
        lastVisitedRoute: url
      };
    }
    case UPDATE_SCHOOL: {
      const { organization } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          Organization: organization
        }
      };
    }

    case UPDATE_STUDENT_USER: {
      const { student, user } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          ...user,
          Student: { ...student }
        }
      };
    }

    //Change super admin view
    case CHANGE_SUPERADMIN_VIEW: {
      const { token, user, expiredAt, isViewChanged } = action.payload;
      return {
        ...state,
        token: token,
        user: user,
        expiredAt: expiredAt,
        superAdmin: {
          ...state.superAdmin,
          isViewChanged: isViewChanged
        }
      };
    }
    default:
      return state;
  }
};

export default auth;